import { FC } from 'react';
import { DeliveryAddressDetails } from './DeliveryAddressDetails';
import { StorePickupDetails } from './StorePickupDetails';
import { selectFulfillmentGroup, IOpenedFrom } from '../../utils/order-details';
import { IOrderDetails } from '../../models/order-details';

interface IFulfillmentAddressDetails {
  orderDetails?: IOrderDetails;
  /**
   * The card the drawer was opened from — the whole distribution, or just its
   * `distributionType`. An order can carry a pickup group and a delivery group
   * at once, and the card decides which of them this drawer describes; without
   * it a mixed order's delivery card shows the store's address.
   */
  distribution?: IOpenedFrom;
}

/**
 * A group with a `storePickup` is a pickup, whatever its fulfillment code says.
 * The presence of the block is what decides which address to show.
 */
export const FulfillmentAddressDetails: FC<IFulfillmentAddressDetails> = ({
  orderDetails,
  distribution,
}) => {
  const group = selectFulfillmentGroup(orderDetails, distribution);

  if (!group) {
    return null;
  }

  if (group?.storePickup) {
    return <StorePickupDetails storePickup={group.storePickup} />;
  }

  return <DeliveryAddressDetails shippingAndHandling={group?.shippingAndHandling} />;
};
